export const destinationCategoriesOptions = [
    {
        key: "ring_group",
        value: "ring_group",
        text: "Ring Groups",
    },
    {
        key: "call_queue",
        value: "call_queue",
        text: "Call Queues",
    },
    {
        key: "direct_extension",
        value: "direct_extension",
        text: "Direct Extensions",
    },
    {
        key: "forwarding_number",
        value: "forwarding_number",
        text: "Forwarding Numbers",
    },
    {
        key: "ivr",
        value: "ivr",
        text: "IVR Prompts",
    },
    {
        key: "company_voicemail",
        value: "company_voicemail",
        text: "Company VM Box",
    },
    {
        key: "personal_voicemail",
        value: "personal_voicemail",
        text: "Personal VM Box",
    },
]